class PaceConverter {
    constructor(formId, mode, outputId) {
        this.formId = formId;
        this.mode = mode;
        this.outputId = outputId;
        this._output = "00:00";
        this._minutes = 0;
        this._seconds = 0;
        this.initializeForm();
    }
    set minutes(value) {
        const parsedValue = parseInt(value, 10);
        this._minutes = isNaN(parsedValue) ? 0 : parsedValue;
    }
    set seconds(value) {
        const parsedValue = parseInt(value, 10);
        this._seconds = isNaN(parsedValue) ? 0 : parsedValue;
    }
    initializeForm() {
        const form = document.getElementById(this.formId);
        if (!form) {
            console.error("Form not found");
            return;
        }
        form.addEventListener('input', (event) => {
            const target = event.target;
            if (target.name) {
                this.handleInputChange(target.value, target.name);
            }
        });
        form.addEventListener('click', (event) => {
            const target = event.target;
            if (target.id == "convert") {
                this.convert();
            }
        });
    }
    handleInputChange(value, name) {
        if (name in this) {
            this[name] = value;
        }
        else {
            console.warn(`No property found for name: ${name}`);
        }
    }
    convert() {
        if (this.mode == 1) {
            this.minutesPerMileToMinutesPerKm();
        }
        else {
            this.minutesPerKmToMinutesPerMile();
        }
        this.printResult();
    }
    minutesPerKmToMinutesPerMile() {
        let totalSeconds = this._minutes * 60 + this._seconds;
        let newMinutes = Math.floor(totalSeconds * RunningHelpers.MileInKm / 60);
        let newSeconds = Math.round((totalSeconds * RunningHelpers.MileInKm) % 60);
        let time = new Date(0, 0, 0, 0, newMinutes, newSeconds);
        this._output = RunningHelpers.printTime(time, false);
    }
    minutesPerMileToMinutesPerKm() {
        let totalSeconds = this._minutes * 60 + this._seconds;
        let newMinutes = Math.floor(totalSeconds / RunningHelpers.MileInKm / 60);
        let newSeconds = Math.round((totalSeconds / RunningHelpers.MileInKm) % 60);
        let time = new Date(0, 0, 0, 0, newMinutes, newSeconds);
        this._output = RunningHelpers.printTime(time, false);
    }
    printResult() {
        var div = document.getElementById(this.outputId);
        if (div) {
            div.innerHTML = this._output;
        }
    }
}
//# sourceMappingURL=PaceConverter.js.map